import React, { useContext } from 'react';
import { FlowConfigContext } from '../../../providers/FlowConfigContext';
import { useTranslation } from 'react-i18next';
import Button, { ButtonStyle } from '../../../common/components/Button/Button';
import ButtonContainer from '../../../common/components/Button/ButtonContainer';
import TitleContainer from '../../../common/components/TitleContainer/TitleContainer';

export default function TokenActiveMinimal(): React.ReactElement {
  const { flowSuccessful, networkName } = useContext(FlowConfigContext);
  const { t } = useTranslation();

  const onConfirm = () => {
    flowSuccessful();
  };

  return (
    <>
      <header className="flex-grow-0 flex-shrink-0 flex justify-center items-center mb-4">
        <span className="text-5xl">🎉</span>
      </header>

      <TitleContainer center>
        <h1 data-testid="screens.tokenActive.titleMinimal">
          {t('screens.tokenActive.titleMinimal', { context: networkName })}
        </h1>
      </TitleContainer>

      <ButtonContainer>
        <Button style={ButtonStyle.DEFAULT} disabled={false} loading={false} dataTestid="OK_BUTTON" onClick={onConfirm}>
          <span>{t('screens.tokenActive.buttonLabel', { context: networkName })}</span>
        </Button>
      </ButtonContainer>
    </>
  );
}
